import { getCommon, getData, getTimestampData } from '@/components/report/service';
import { CALCWEIGHT, Aggregator } from '@/models/GenerateCondit/Interrelated';
import moment from 'moment';
import { message } from 'antd';
import { GetOrganizationAuth, InitOrganizationAuth } from '@/services/area';
import { getToDay } from '@/utils/date';
import { crudRequest } from '@/services/api';

const weekArray = ['第一周', '第二周', '第三周', '第四周'];
const dayArray = ['0', '-1', '-2', '-3', '-4', '-5', '-6'];

let [startDate] = getToDay();

export default {
  namespace: 'loadingrateboarddetail',
  state: {
    searchParams: {
      lineTime: moment(startDate).subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
      departureCenter: undefined,
      arrivalCenter: '',
      transportLineType: ['长线', '短线', '支线'],
      filling: ['填仓货'],
      weekType: ['工作日', '周六', '周日'],
      directionType: '分拨-省',
    },
    onSearch: false,
    startDate: '',
    endDate: '',
    transportLineType: '',
    weekType: '',
    dayTableDatas: [],
    weekTableDatas: [],
    access: {
      isHead: false,
      isArea: false,
      isCenter: true,
      code: '',
    },
    lineMonthSelectType: 'day',
  },

  effects: {
    /**
     * 获取周累计值
     */
    *getWeekSumData({ payload }, { call, put, select }) {
      const {
        departureCenter,
        arrivalCenter,
        transportLineType,
        filling,
        weekType,
        startDate,
        endDate,
        directionType,
      } = payload;

      let andFilters = [];
      let dimensions = [
        'monthType',
        // 'totalCalcWeightRate', // 结算装载率=流向转载率
      ];

      let directionKey = handleDirectionFilter(
        directionType,
        departureCenter,
        andFilters,
        arrivalCenter,
      );
      dimensions.push(...directionKey);

      let inFilters = [
        {
          key: 'monthType',
          value: [...weekArray],
        },
      ];
      if (transportLineType && transportLineType.length !== 3) {
        inFilters.push({ key: 'transportLineType', value: transportLineType });
      }
      if (weekType && weekType.length) {
        inFilters.push({ key: 'weekType', value: weekType });
      }

      let notFilters = [];

      let aggregators = [
        new Aggregator('doubleSum', 'actualCapacity', 'actualCapacity'),
        // new Aggregator('doubleSum', 'totalCalcWeight', 'totalCalcWeight'), // 重量
      ];

      // 填仓
      if (filling && filling?.length > 0) {
        aggregators.push(new Aggregator('doubleSum', 'totalCalcWeight', 'totalCalcWeight'));
      } else if (filling && filling?.length === 0) {
        aggregators.push(new Aggregator('doubleSum', 'totalCalcWeight', 'unFillingCalcWeight'));
      }

      const filter = {
        // title: '中转发出-实际',
        dimensions,
        simpleGranularity: 'day',
        startDate: startDate,
        endDate: endDate,
        andFilters: andFilters,
        inFilters: inFilters,
        notFilters,
      };

      const volumeResult = yield call(getCommon, {
        ...filter,
        aggregators,
        dataSource: 't_load_rate_comp_result',
      });
      if (!volumeResult) {
        // message.error('查询出现错误');
        return;
      }

      let weekTableDatas = handleData1(
        weekArray,
        volumeResult,
        (item) => item.monthType,
        directionKey,
      );

      crudRequest('/api/route/loadingRateBoardDetail/search_week');
      yield put({
        type: 'updateState',
        payload: {
          weekTableDatas,
        },
      });
    },

    /**
     * 获取单日值
     */
    *getDaySumData({ payload }, { call, put, select }) {
      let loadingrateboarddetail = yield select(
        ({ loadingrateboarddetail }) => loadingrateboarddetail,
      );
      const { access, searchParams } = loadingrateboarddetail;

      const {
        lineTime, // 日期
        departureCenter, // 出发组织
        arrivalCenter, // 到达组织
        transportLineType, // 线路类型
        filling, // 填仓货
        // weekType, // 周类型
        directionType, // 流向类型
      } = searchParams;

      if (!access.isHead && departureCenter == null) {
        message.warn('请选择出发组织');
        return;
      }

      const startDate =
        lineTime &&
        moment(lineTime).startOf('day').subtract(6, 'days').format('YYYY-MM-DD HH:mm:ss');
      const endDate = lineTime && moment(lineTime).endOf('day').format('YYYY-MM-DD HH:mm:ss');

      let inFilters = [];
      let andFilters = [];

      if (transportLineType && transportLineType.length !== 3) {
        inFilters.push({ key: 'transportLineType', value: transportLineType });
      }

      // if (departureCenter && departureCenter.length > 0) {
      //   if (departureCenter.length == 2) {
      //     andFilters.push({ key: 'departureCenter', value: departureCenter.lastItem });
      //   } else {
      //     andFilters.push({
      //       key: 'departureProvinceArea',
      //       value: departureCenter.lastItem,
      //     });
      //   }
      // }
      // if (arrivalCenter && arrivalCenter.length > 0) {
      //   if (arrivalCenter.length == 2) {
      //     andFilters.push({ key: 'arrivalCenter', value: arrivalCenter.lastItem });
      //   } else {
      //     andFilters.push({ key: 'arrivalProvinceArea', value: arrivalCenter.lastItem });
      //     // andFilters.push({ key: 'arrivalProvinceArea', value: '云南省区' });
      //   }
      // }

      // let notFilters = [];

      let aggregators = [
        new Aggregator('doubleSum', 'actualCapacity', 'actualCapacity'), // 运力
        // new Aggregator('doubleSum', 'calcWeight', 'calcWeight'), // 重量
        // new Aggregator('doubleSum', 'totalCalcWeight', 'totalCalcWeight'), // 重量
        // new Aggregator('doubleSum', 'totalCalcWeight', 'unFillingCalcWeight'), // 重量

        // new Aggregator('doubleSum', 'totalVolume', 'totalVolume'),
      ];
      // 填仓
      if (filling && filling?.length > 0) {
        aggregators.push(new Aggregator('doubleSum', 'totalCalcWeight', 'totalCalcWeight'));
      } else if (filling && filling?.length === 0) {
        aggregators.push(new Aggregator('doubleSum', 'totalCalcWeight', 'unFillingCalcWeight'));
      }

      let dimensions = [
        '__time',
        // 'departureProvinceArea',
        // 'arrivalProvinceArea',
        // 'direction', // 流向
        // 'transportLineType', // 线路类型
        // 'departureCenter', // 流向出发分拨
        // 'arrivalCenter', // 流向到达分拨
        // 'totalCalcWeightRate', // 结算装载率=流向转载率
      ];
      let directionKey = handleDirectionFilter(
        directionType,
        departureCenter,
        andFilters,
        arrivalCenter,
      );
      dimensions.push(...directionKey);

      const filter = {
        dimensions,
        simpleGranularity: 'day',
        startDate,
        endDate,
      };

      const volumeResult = yield call(getCommon, {
        ...filter,
        aggregators,
        dataSource: 't_load_rate_comp_result',
        andFilters,
        // notFilters,
        inFilters,
      });

      if (!volumeResult) {
        // message.error('查询出现错误');
        return;
      }

      let dayTableDatas = handleData1(
        dayArray,
        volumeResult,
        (item) => moment(item.druidDefaultSearchTime).diff(endDate, 'days'),
        directionKey,
      );

      crudRequest('/api/route/loadingRateBoardDetail/search_day');

      yield put({
        type: 'updateState',
        payload: {
          dayTableDatas,
        },
      });
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },
  },
};

function handleDirectionFilter(directionType, departureCenter, andFilters, arrivalCenter) {
  let directionKey = [];
  let departKey = 'departureProvinceArea';
  let arriveKey = 'arrivalProvinceArea';
  //
  if (directionType === '省-分拨') {
    arriveKey = 'arrivalCenter';
  } else if (directionType === '分拨-省') {
    departKey = 'departureCenter';
  } else if (directionType === '分拨-分拨') {
    departKey = 'departureCenter';
    arriveKey = 'arrivalCenter';
  }
  //
  if (departureCenter && departureCenter.length > 0) {
    andFilters.push({ key: departKey, value: departureCenter.lastItem });
  }
  if (arrivalCenter && arrivalCenter.length > 0) {
    andFilters.push({ key: arriveKey, value: arrivalCenter.lastItem });
  }
  directionKey.push(departKey, arriveKey);

  return directionKey;
}

/**
 *
 * @param {Array} columeArray 字段数组
 * @param {Array} goodsResult 货物
 * @param {Array} volumeResult
 * @param {Function} columnName 数据对应字段key
 * @returns
 */
function handleData1(columeArray, volumeResult, columnName, directionKey) {
  let allCountInit = columeArray.reduce((pre, current) => {
    pre[current] = 0;
    return pre;
  }, {});

  const goodsData = JSON.parse(volumeResult.data || null)
    .map((item) => item.event)
    .map((item) => {
      return {
        ...item,
        calcWeight: item?.totalCalcWeight ? Math.abs(item.totalCalcWeight) : item.totalCalcWeight,
      };
    })
    .reduce(
      (pre, current) => {
        let direction = `${current[directionKey[0]]}-${current[directionKey[1]]}`.replace(
          /分拨中心|经营本部|省区|营运区|管理区/g,
          '',
        );

        let name = columnName(current);
        if (pre[direction]) {
          pre[direction][name] = pre[direction][name] + current.calcWeight;
        } else {
          pre[direction] = { ...allCountInit, [name]: current.calcWeight };
        }

        pre['合计'] = {
          ...pre['合计'],
          [name]: pre['合计']?.[name] + current.calcWeight,
        };
        return pre;
      },
      { 合计: { ...allCountInit } },
    );

  const volumeData = JSON.parse(volumeResult.data || null)
    .map((item) => item.event)
    .reduce(
      (pre, current) => {
        let name = columnName(current);
        // 流向
        let direction = `${current[directionKey[0]]}-${current[directionKey[1]]}`.replace(
          /分拨中心|经营本部|省区|营运区|管理区/g,
          '',
        );

        if (pre[direction]) {
          pre[direction][name] = pre[direction][name] + current.actualCapacity;
        } else {
          pre[direction] = { ...allCountInit, [name]: current.actualCapacity };
        }

        pre['合计'] = {
          ...pre['合计'],
          [name]: pre['合计']?.[name] + current.actualCapacity,
        };
        return pre;
      },
      { 合计: { ...allCountInit } },
    );

  // 计算合计
  let sumResult = columeArray.reduce((pre, current) => {
    if (goodsData['合计']?.[current] && volumeData['合计']?.[current]) {
      pre[`${current}Goods`] = goodsData['合计']?.[current];
      pre[`${current}Volume`] = volumeData['合计']?.[current];
      pre[current] = goodsData['合计']?.[current] / volumeData['合计']?.[current] / 1000;
    }
    return pre;
  }, {});

  // 计算合计月累计
  let monthSumResult = columeArray.reduce(
    (pre, current) => {
      if (goodsData['合计']?.[current] && volumeData['合计']?.[current]) {
        pre['calcWeight'] += goodsData['合计']?.[current];
        pre['actualCapacity'] += volumeData['合计']?.[current];
      }
      return pre;
    },
    { calcWeight: 0, actualCapacity: 0 },
  );

  let tableDatas = [
    {
      direction: '合计',
      ...sumResult,
      totalGoods: monthSumResult.calcWeight,
      totalVolume: monthSumResult.actualCapacity,
      month: monthSumResult.calcWeight / monthSumResult.actualCapacity / 1000,
    },
  ];

  // let countData = {}
  Object.entries(goodsData).forEach(([key, value]) => {
    if (key === '合计') {
      return;
    }

    let weekResult = columeArray.reduce((pre, current) => {
      pre[`${current}Goods`] = value?.[current];
      pre[`${current}Volume`] = volumeData[key]?.[current];
      if (!pre['totalGoods']) {
        pre['totalGoods'] = 0;
      }
      if (!pre['totalVolume']) {
        pre['totalVolume'] = 0;
      }
      pre['totalGoods'] += value?.[current];
      pre['totalVolume'] += volumeData[key]?.[current];
      pre[current] = value?.[current] / volumeData[key]?.[current] / 1000;
      return pre;
    }, {});
    weekResult['month'] = weekResult['totalGoods'] / weekResult['totalVolume'] / 1000;

    if (value && volumeData[key]) {
      tableDatas.push({
        direction: key,
        ...weekResult,
      });
    }
  });
  return tableDatas;
}
